import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonasteryAbandoned1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONASTERY_ABANDONED1;
}

export default MonasteryAbandoned1PoiTileEntity;
